module.exports = __webpack_public_path__ + "static/img/加入采购单@2x.a6e2c0e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/mobile/首页/加入采购单@2x.png
// module id = GNUn
// module chunks = 192